import * as React from "react";
import styled from "styled-components";

export function FormInput({ id, label, type }) {
  return (
    <InputWrapper>
      <label htmlFor={id} className="visually-hidden">{label}</label>
      {type === "textarea" ? (
        <StyledTextarea
          id={id}
          name={id}
          placeholder={label}
          aria-label={label}
        />
      ) : (
        <StyledInput
          id={id}
          name={id}
          type={type}
          placeholder={label}
          aria-label={label}
        />
      )}
    </InputWrapper>
  );
}

const InputWrapper = styled.div`
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background-color: rgba(255, 255, 255, 0.07);
  margin-top: 25px;
  padding: 16px 20px;
  position: relative;
  transition: all 0.3s ease;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5px);
  
  &:focus-within {
    border-color: rgba(255, 255, 255, 0.3);
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.1), 
                inset 0 2px 4px rgba(0, 0, 0, 0.1);
    transform: translateY(-2px);
  }

  @media (max-width: 991px) {
    max-width: 100%;
  }

  .visually-hidden {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
`;

const inputStyles = `
  width: 100%;
  border: none;
  outline: none;
  background: transparent;
  color: #ffffff;
  font: inherit;
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.6);
    transition: color 0.3s ease;
  }
  
  &:focus::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }
`;

const StyledInput = styled.input`
  ${inputStyles}
`;

const StyledTextarea = styled.textarea`
  ${inputStyles}
  resize: vertical;
  min-height: 120px;
`;